import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestInventory} from "../../../redux/Actions/inventory.actions";
import {
  getInventoriesList,
  getInventoryPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/inventory.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {inventoryListURL} from "./inventoryTable.constants";

export const useFetchInventories = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestInventory());
  };

  const refetch = () => {
    dispatch(requestInventory(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useInventoryTableData = () => {
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchInventories();
  const {setPageUrl} = usePageURLContext();
  const inventories = useSelector(getInventoriesList);
  const inventoryUrls = useSelector(getInventoryPaginationUrls);
  const totalCount = useSelector(getTotalCount);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (inventories.length === 1) {
      // If the last inventory on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePagination = (page) => {
    const url = currentPage < page ? inventoryUrls?.nextUrl : inventoryUrls?.prevUrl;
    dispatch(requestInventory(url));
    setCurrentPage(page);
    setPageUrl(url);
  };
  const paginationConfig = {
    currentPage,
    onPageChange: handlePagination,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(inventoryListURL, tokens);
      dispatch(requestInventory(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };
  return {
    fetchAfterDelete,
    inventories,
    handleSearch,
    paginationConfig,
    totalCount,
  };
};
